import classNames from "classnames";
import React from "react";
import { MainWideTextClassName } from "../styles";

export const Quote: React.FC<{
  title?: string | null;
  author?: string | null;
}> = ({ title, author }) => {
  return (
    <section
      data-component="Quote"
      className="py-section page-grid max-width relative"
    >
      <div className={classNames(MainWideTextClassName)}>
        <span className="text p5 block text-hyacinth">“</span>
        <h3 className="h3">{title}</h3>
        <div className="relative">
          <span className="p5 -top-15px absolute right-10px text-hyacinth">
            ”
          </span>
        </div>
        {author && <p className="p3 pt-20px text-hyacinth">{author}</p>}
      </div>
    </section>
  );
};
